<p-drawer
  [visible]="(opened$ | async) ?? false"
  (visibleChange)="$event ? null : unsetSelected()"
  position="right"
  [style]="{ width: '50vw' }"
>
  <ng-template #header>
    <ng-content select="[header]"></ng-content>
  </ng-template>
  @if (overlayModalOpen) {
  <div
    class="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
    style="background-color: rgba(255,255,255,.9); z-index: 4000;"
  >
    <div class="rounded-4 p-5 bg-white shadow">
      @if (overlayModalTemplate) {
      <ng-container [ngTemplateOutlet]="overlayModalTemplate"></ng-container>
      }
    </div>
  </div>
  }
  <ng-content></ng-content>
</p-drawer>